import { CompensationMethodData } from "@redotech/redo-customer-portal-shared/flow/util";
import { Step } from "@redotech/redo-model/return-flow";
import { memo, useEffect } from "react";

export const SubmitRepair = memo(function SubmitRepair({
  submitItem,
}: {
  submitItem: (data: CompensationMethodData) => void;
  flowStep: Step.SubmitRepair;
}) {
  useEffect(() => {
    submitItem({});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <div />;
});
